"use client";

import { Moon, Sun } from "lucide-react";
import { applyTheme, getCurrentTheme } from "@/lib/theme";

/**
 * دکمه تم روشن/تیره.
 * - آیکن فقط با CSS (dark:) عوض میشه، پس هیچ فلش یا mismatch هیدریشن نداریم.
 * - در موبایل مخفی است (hidden md:inline-flex).
 */
export default function ThemeToggle() {
    const toggle = () => {
        applyTheme(getCurrentTheme() === "dark" ? "light" : "dark");
    };

    return (
        <button
            type="button"
            onClick={toggle}
            title="تغییر تم روشن / تیره"
            aria-label="تغییر تم روشن / تیره"
            className="hidden md:inline-flex cursor-pointer items-center justify-center rounded-lg p-2 text-gray-700 transition-colors hover:bg-gray-200"
        >
            <Moon className="h-5 w-5 dark:hidden" />
            <Sun className="hidden h-5 w-5 dark:block" />
        </button>
    );
}
